/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/FormResponseBean', 'model/TypeformBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./FormResponseBean'), require('./TypeformBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.TypeformResponse = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.FormResponseBean, root.BpmbuildDevelopmentappspotcom.TypeformBean);
  }
}(this, function(ApiClient, FormResponseBean, TypeformBean) {
  'use strict';

  /**
   * The TypeformResponse model module.
   * @module model/TypeformResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>TypeformResponse</code>.
   * @alias module:model/TypeformResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>TypeformResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TypeformResponse} obj Optional instance to populate.
   * @return {module:model/TypeformResponse} The populated <code>TypeformResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('event_id'))
        obj.eventId = ApiClient.convertToType(data['event_id'], 'String');
      if (data.hasOwnProperty('event_type'))
        obj.eventType = ApiClient.convertToType(data['event_type'], 'String');
      if (data.hasOwnProperty('form_response'))
        obj.formResponse = FormResponseBean.constructFromObject(data['form_response']);
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('typeformList'))
        obj.typeformList = ApiClient.convertToType(data['typeformList'], [TypeformBean]);
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {String} eventId
   */
  exports.prototype.eventId = undefined;

  /**
   * @member {String} eventType
   */
  exports.prototype.eventType = undefined;

  /**
   * @member {module:model/FormResponseBean} formResponse
   */
  exports.prototype.formResponse = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {Array.<module:model/TypeformBean>} typeformList
   */
  exports.prototype.typeformList = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/TypeformResponse.js